/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

export interface ProjectCalculationsInvestorReportRetrieve$Params {
  /**
   * ID венчурного фонда
   */
  fund_pk?: string;
  scenario_pk: string;
}

export function projectCalculationsInvestorReportRetrieve(
  http: HttpClient,
  rootUrl: string,
  params: ProjectCalculationsInvestorReportRetrieve$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, projectCalculationsInvestorReportRetrieve.PATH, 'get');
  if (params) {
    rb.query('fund_pk', params.fund_pk, {});
    rb.path('scenario_pk', params.scenario_pk, {});
  }

  return http.request(rb.build({ responseType: 'text', accept: '*/*', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as BakendHttpResponse<void>;
    }),
  );
}

projectCalculationsInvestorReportRetrieve.PATH = '/api/project_calculations/investor-report/{scenario_pk}/';
